import BtRealization from '@/components/bt-realization/BtRealization'
import BtRealizationNew from '@/components/bt-realization/BtRealizationNew'
import BtRealizationExpense from '@/components/bt-realization/BtRealizationExpense'
import BtRealizationExpenseNew from '@/components/bt-realization/BtRealizationExpenseNew'
import BtRealizationExpenseDetail from '@/components/bt-realization/BtRealizationExpenseDetail'
import BtRealizationSelectSppd from '@/components/bt-realization/BtRealizationSelectSppd'
import BtRealizationDetail from '@/components/bt-realization/BtRealizationDetail'

const BusinessTripRealizationRouter = [
  {
    path: 'btrealization',
    name: 'business-trip-realization-list',
    component: BtRealization,
    props: true
  },
  {
    path: 'btrealization/select-sppd',
    name: 'business-trip-realization-select-sppd',
    component: BtRealizationSelectSppd,
    props: true
  },
  {
    path: 'btrealization/new',
    component: BtRealizationNew,
    props: true,
    children: [
      {
        path: '',
        name: 'business-trip-new-realization',
        component: BtRealizationExpense,
        props: true
      },
      {
        path: 'new-expense',
        name: 'business-trip-new-realization-new-expense',
        component: BtRealizationExpenseNew,
        props: true
      },
      {
        path: 'detail-expense',
        name: 'business-trip-new-realization-expense-detail',
        component: BtRealizationExpenseDetail,
        props: true
      }
    ]
  },
  {
    path: 'btrealization/:id',
    component: BtRealizationDetail,
    props: true,
    children: [
      {
        path: '',
        name: 'business-trip-realization-detail',
        component: BtRealizationExpense,
        props: true
      },
      {
        path: 'new-expense',
        name: 'business-trip-realization-detail-new-expense',
        component: BtRealizationExpenseNew,
        props: true
      },
      {
        path: 'detail-expense',
        name: 'business-trip-realization-detail-expense-detail',
        component: BtRealizationExpenseDetail,
        props: true
      }
    ]
  }
]

export default BusinessTripRealizationRouter



// WEBPACK FOOTER //
// ./src/router/BusinessTripRealizationRouter.js